// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a0fc8a7","952":"e50b3b5b"}[chunkId] + ".chunk.js";
};